<template>
  <section class="mb-20 lg:mb-[160px]">
    <PrivacyPolicyBanner :title="$t('titles.privacy_policy')" />
    <PrivacyPolicyContent class="mt-4 lg:mt-6" />
    <ContactUsInfo class="mt-8 lg:mt-14 lg:container mx-4" />
  </section>
</template>

<script>
import { renderHead } from '@helper/head/head-home'
import { mapGetters } from 'vuex'
import PrivacyPolicyBanner from '@/components/pages/privacy-policy/privacy-policy-banner.vue'
import PrivacyPolicyContent from '@/components/pages/privacy-policy/privacy-policy-content'
import ContactUsInfo from '@/components/pages/contact-us/contact-us-info'

export default {
  name: 'PrivacyPolicyPage',
  components: { PrivacyPolicyBanner, PrivacyPolicyContent, ContactUsInfo },
  auth: false,
  layout: 'main',
  async asyncData ({ store }) {
    await store.dispatch('local/asyncDataPolicy')
  },
  head () {
    return renderHead({ meta: this.getMeta })
  },
  computed: {
    ...mapGetters('global', ['getMeta'])
  }
}
</script>

<style scoped lang="scss">
</style>
